export default {
  toasts: {
    load_error: 'Falha ao carregar as taxas',
    failed_to_save_changes: 'Falha ao guardar as alterações',
    changes_got_saved: 'Alterações guardadas',
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  rates: {
    title: 'Margem de processamento',
    description:
      'Percentagem em %, mais um valor fixo e mínimo opcionais por cobrança. «Qualquer método de pagamento» aplica-se quando não existe uma taxa específica do método.',
    default: {
      inherits:
        'Não há nenhuma taxa Adyen definida, pelo que os restaurantes deste parceiro no Adyen da FoodAmigos pagam a taxa predefinida da FoodAmigos abaixo. Uma taxa definida aqui substitui-a; uma taxa definida num restaurante individual continua a ter precedência.',
      overridden:
        'A taxa Adyen própria deste parceiro substitui a taxa predefinida da FoodAmigos abaixo para os seus restaurantes no Adyen da FoodAmigos. Remova-a para voltar à taxa predefinida.',
      own_adyen:
        'Este parceiro processa pagamentos na sua própria conta Adyen. Os seus restaurantes não pagam comissão de processamento, a menos que seja definida uma taxa aqui ou num restaurante individual.',
      master:
        'Estas são as taxas predefinidas da FoodAmigos. Todos os parceiros no Adyen da FoodAmigos sem uma taxa Adyen própria utilizam-nas.',
      rows_title: 'Taxas predefinidas da FoodAmigos',
    },
  },
};
